import * as React from 'react'

import {
  ParentUserNav as ParentUserNavPresenter,
  IProps as IParentUserNav,
} from './presenter'
export {
  PAGE_TYPE_PROFILE,
  PAGE_TYPE_DASHBOARD,
  PAGE_TYPE_CONTACT,
  PAGE_TYPE_RESERVE,
  PAGE_TYPE_JOBPOST,
  PAGE_TYPE_FAVORITE,
  PAGE_TYPE_MATCHING,
  PAGE_TYPE_POINT,
  PAGE_TYPE_ALBUM,
  PAGE_TYPE_PAYMENT,
  PAGE_TYPE_TRIAL_SEARCH_SITTER,
  PAGE_TYPE_TRIAL_SEARCH_HOUSEKEEPER,
} from './presenter'

export type IProps = IParentUserNav

export const ParentUserNav = (props: IProps): JSX.Element => {
  return <ParentUserNavPresenter {...props} />
}

export default ParentUserNav
